import React from 'react';

const Logo: React.FC<{ size?: number; showText?: boolean }> = ({ size = 40, showText = true }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 15px rgba(99, 102, 241, 0.4)',
        border: '2px solid rgba(99, 102, 241, 0.3)',
        width: size,
        height: size,
        overflow: 'hidden'
      }}>
        <img 
          src="/logo-new.png" 
          alt="BringIt" 
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover',
            display: 'block',
            transform: 'scale(1.4)',
            borderRadius: '8px'
          }}
        />
      </div>
      {showText && (
        <span style={{ 
          fontSize: size * 0.6, 
          fontWeight: 'bold', 
          color: '#333333',
          fontFamily: 'Arial, sans-serif'
        }}>
          BringIt
        </span>
      )}
    </div>
  );
};

export default Logo;
